<template>
	<div :class="['nk-label-sa', 'advance-floating']">
		<template v-if="settings.popoverOnly">
			<div class=" mr-1">
				<nk-popover v-show="checkProductBalanceAccess" :options="componentOptions.popover"></nk-popover>
			</div>
		</template>

		<template v-else-if="settings.advance">
			<div v-if="product && product.name">{{ product.name }}</div>
			<div v-if="product && !settings.hideBalance" :class="['balance', { 'text-red': product.lastStockOnReceiptHawala < 0 }, { 'text-green': product.lastStockOnReceiptHawala >= 0 }]">
				<b>(<span>{{ $t('sale.factor.stock') }}: </span><span>{{ product.lastStockOnReceiptHawala != 0 ? checkProductBalanceAccess ? monify(product.lastStockOnReceiptHawala, false) : '---' : '-' }} </span>)</b>
			</div>
			<div>
				<nk-popover v-show="checkProductBalanceAccess" :options="componentOptions.popover"></nk-popover>
			</div>
		</template>

		<template v-else>
			<div v-if="product && product.name">{{ product.name }}</div>
		</template>

		<div ref="popContent" style="display: none">
			<div class="pop-body">
				<div v-if="product?.imageUrl || settings?.imageUrl" class="product-image-container"> <img width="80" height="80" class="rounded-circle" loading="lazy" :src="product?.imageUrl || settings?.imageUrl" /> </div>
				<div> {{ $t('sale.product.f.code') }}: {{ product?.code?.toString().toLocaleDigits() }} </div>
				<div> {{ $t('sale.product.f.name') }}: {{ product?.name?.toLocaleDigits() }} </div>
				<div> {{ $t('sale.product.f.stock-by-factor') }}: {{ product?.lastStockOnFactor }} </div>
				<div> {{ $t('sale.product.f.stock-by-warehouse') }}: {{ product?.lastStockOnReceiptHawala }} </div>
				<div> {{ $t(`sale.factor.last-${this.factorType.toLowerCase()}`) }}: <span v-html="lastFactor"></span></div>
				<ul class="toolbar">
					<li><a href="javascript:void(0)" @click.stop="showProductDetail()"><i class="fa fa-edit"></i></a></li>
					<li><a href="javascript:void(0)" @click.stop="loadProductData()"><i class="fa fa-redo"></i></a></li>
					<li><a href="javascript:void(0)" @click.stop="openProductCardex()"><i class="fa fa-file-chart-line"></i></a></li>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
	import _ from 'lodash'
	import $ from 'jquery'
	import { post } from '~/plugins/nikan-api'
	import Endpoints from '@nikan/endpoints'
	import tv from '@nikan/text-visualizer'
	import { mapGetters, mapState } from 'vuex'
	import ProductModify from '~/views/sale/products/product-modify'
	import PersianDate from 'persian-date'
	import { defineAsyncComponent } from 'vue'

	export default {
		props: ['modelValue', 'options', 'params'],
		data() {
			return {
				settings: {
					advance: false,
					popoverOnly: false,
					hideBalance: false,
				},
				componentOptions: {
					popover: {
						title: this.$t('sale.product.tab.productInfo'),
						contentElement: '',
						//preventCloseDropdown: false
					}
				},
				lastFactor: '...',
				warehouseStocks: '...'
			}
		},
		created() {
			this.settings = _.merge(this.settings, this.options)
			if (this.params?.options) this.settings = _.merge(this.settings, this.params.options)
		},
		mounted() {
			this.componentOptions.popover.contentElement = $(this.$refs.popContent)
		},
		computed: {
			...mapGetters({
				checkProductBalanceAccess: 'appContext/checkAccessProductBalanceObserve',
			}),
			...mapState('appContext', {
				status: state => state
			}),
			// settings() {
			// 	return Object.assign({}, this.options)
			// },
			type() {
				return getType(this.settings.type, this.settings.format)
			},
			factorType() {
				return this.settings.factorType || 'sale'
			},
			product() {
				if (this.params?.options && this.params.options.data)
					return this.params.options.data

				return this.options?.data || null
			}
		},
		methods: {
			formatPrice(price, curreny = true) {
				var val = String(tv(Math.abs(price), { type: 'price' })).toLocaleDigits()
				if (curreny)
					val += ' ' + this.status.company.currency.name
				return val
			},
			balanceType() {
				return this.product?.balance < 0 ? this.$t('account.short-debit') : this.product?.balance > 0 ? this.$t('account.short-credit') : ''
			},
			showProductDetail() {
				_.head(document.getElementsByTagName('body')).force_dropdown_close = true
				var url = Endpoints.getUrl('sale.product.get')
				var wait = this.$wait(this.$refs.popContent.closest('.popover-body'), { size: 'small' })
				post(url, { Id: this.product?.id })
					.then(result => {
						wait.end()
						this.showModal({ component: ProductModify, data: result.data })
							.then((response) => {

							})
							.catch(() => {

							})
					})
					.catch(() => {
						wait.end()
					})
			},
			loadProductData() {
				var wait = this.$wait(this.$refs.popContent.closest('.popover-body'), { size: 'small' })
				var request = {
					floatingCenterId: this.product?.id,
					type: this.factorType
				}
				post(Endpoints.getUrl('sale.factor.get-floating-center-extra-data'), request)
					.then(result => {
						wait.end()
						var lastFactor = result.data.lastFactor
						if (!lastFactor)
							this.lastFactor = this.$t('sale.factor.m.factor-not-found')
						else {
							var date = new PersianDate(lastFactor.date).format('YYYY' + '/' + 'MM' + '/' + 'DD')
							this.lastFactor = `<br/>${this.$t('sale.factor.f.code')}: ${String(lastFactor.code).toLocaleDigits()}`
							this.lastFactor += `<br/>${this.$t('sale.factor.f.date')}: ${String(date).toLocaleDigits()}`
							this.lastFactor += `<br/>${this.$t('sale.factor.f.totalPayableAmount')}: ${this.formatPrice(lastFactor.totalPayableAmount)} `
						}
					})
					.catch(() => {
						wait.end()
					})
			},
			openProductCardex() {
				this.showModal({
					component: defineAsyncComponent(() => import('~/views/reports/product-cardex.vue')),
					options: {
						product: this.product
					},
				})
					.then((res) => { })
					.catch(() => { })
			}
		}
	}
</script>
<style>

	.tr.selected .advance-floating .balance,
	.tr.selected .advance-floating a {
		color: #fff !important;
	}

	.nk-label-sa.advance-floating {
		display: flex;
	}

	.nk-label-sa.advance-floating>div {
		margin-left: 5px;
	}

	.pop-body>div {
		padding: 3px;
		border-bottom: 1px dashed #ccc;
	}

	.pop-body>div:last-of-type {
		padding: 3px;
		border-bottom: none;
	}

	.product-image-container {
		display: flex;
		justify-content: center;
		padding-bottom: 0.5rem;
	}
</style>
